import createBaseService from "@/api/base-service.ts";
import type { DocumentationChecklist } from "../../types/documentation-checklist";

const documentationChecklistService = {
	...createBaseService<DocumentationChecklist>("/documentation-checklists"),
};

export default documentationChecklistService;
